import React, { useState, useCallback,useEffect } from 'react';
import { ArrowRight, Play, ShoppingBag,Minus,Plus, Sparkles, Star, TrendingUp, Package } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import configs from '../config/config';
import { useCart } from '../context/CartContext';   // adjust path if needed

const HeroSection = ({ config }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
const {
  addToCart,
  changeQuantity,
  isInCart,
  getQuantity,
} = useCart();
    //const [localQuantities, setLocalQuantities] = useState({});
  const defaultConfig = {
    preset: 'split-layout',
    title: "Discover Your Perfect Style",
    subtitle: "Explore our latest collection of premium fashion pieces crafted for the modern individual.",
    badge: "New Collection 2025",
    ctaPrimary: { text: "Shop Now", link: "/shop" },
    ctaSecondary: { text: "View Details", link: "#" },
    stats: [
      { value: "500+", label: "Products" },
      { value: "50k+", label: "Happy Customers" },
      { value: "4.9", label: "Avg Rating" },
    ],
    product: null,
    devMode: false,
    customStyles: {
      container: {
        padding: 'py-12 md:py-20',
        background: 'bg-white',
        heroImage: '',
        backgroundImage: '',
        titleColor: '#111827',
        subtitleColor: '#4B5563',
        badgeBg: '#f3f4f6',
        badgeText: '#111827',
        ctaPrimaryBg: '#111827',
        ctaPrimaryText: '#ffffff',
        ctaSecondaryBorder: '#6b7280',
        ctaSecondaryText: '#374151',
      },
    },
  };

  const finalConfig = { ...defaultConfig, ...config };
  const {
    preset,
    title,
    subtitle,
    badge,
    ctaPrimary,
    ctaSecondary,
    stats,
    product,
    devMode,
    customStyles,
  } = finalConfig;

  const containerClasses = [];
  const containerStyle = {};

  // Background handling (color / gradient / image / video)
  const bgValue = customStyles.container?.background || 'bg-white';
  const bgImage = customStyles.container?.backgroundImage;

  if (bgValue.startsWith('bg-')) {
    containerClasses.push(bgValue);
  } else {
    containerStyle.background = bgValue;
  }

  if (bgImage) {
    if (bgImage.match(/\.(mp4|webm|mov)$/i)) {
      // Video background
      containerStyle.background = 'black'; // fallback
    } else {
      containerStyle.backgroundImage = `url(${bgImage})`;
      containerStyle.backgroundSize = 'cover';
      containerStyle.backgroundPosition = 'center';
      containerStyle.backgroundRepeat = 'no-repeat';
    }
  }

  if (customStyles.container?.padding) {
    containerClasses.push(customStyles.container.padding);
  }

  const finalContainerClass = containerClasses.join(' ');
 // const [pendingUpdates, setPendingUpdates] = useState({});



  const [wishlist, setWishlist] = useState([]);

  const toggleWishlist = (id) => {
    setWishlist((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

 


  // Helper: render hero media (image or video)
  const renderHeroMedia = (src, alt = "Hero media", className = "") => {
    if (!src) return null;

    const isVideo = src.match(/\.(mp4|webm|mov)$/i);

    if (isVideo) {
      return (
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          className={`w-full h-full object-cover ${className}`}
        />
      );
    }

    return (
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${className}`}
        onError={(e) => {
          e.target.src = 'https://placehold.co/600x600?text=Image+Failed';
        }}
      />
    );
  };

  const SplitLayout = () => (
    <div className={`relative overflow-hidden ${finalContainerClass}`} style={containerStyle}>
      {customStyles.container?.backgroundImage?.match(/\.(mp4|webm|mov)$/i) && (
        <video
          src={customStyles.container.backgroundImage}
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center min-h-[500px] lg:min-h-[680px]">
          <div className="order-2 lg:order-1 py-12 lg:py-20">
            {badge && (
              <div
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                style={{
                  backgroundColor: customStyles.container?.badgeBg || '#f3f4f6',
                  color: customStyles.container?.badgeText || '#111827',
                }}
              >
                <Sparkles className="w-5 h-5" />
                <span className="font-medium">{badge}</span>
              </div>
            )}
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
              style={{ color: customStyles.container?.titleColor || '#111827' }}
            >
              {title}
            </h1>
            <p
              className="text-lg md:text-xl mb-10 max-w-xl leading-relaxed"
              style={{ color: customStyles.container?.subtitleColor || '#4B5563' }}
            >
              {subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                className="group px-8 py-4 rounded-full font-semibold transition-all flex items-center justify-center shadow-md"
                style={{
                  backgroundColor: customStyles.container?.ctaPrimaryBg || '#111827',
                  color: customStyles.container?.ctaPrimaryText || '#ffffff',
                }}
              >
                {ctaPrimary?.text || "Shop Now"}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              {ctaSecondary?.text && (
                <button
                  className="px-8 py-4 rounded-full font-semibold border-2 transition-all flex items-center justify-center"
                  style={{
                    borderColor: customStyles.container?.ctaSecondaryBorder || '#6b7280',
                    color: customStyles.container?.ctaSecondaryText || '#374151',
                  }}
                >
                  <Play className="mr-2 w-5 h-5" />
                  {ctaSecondary.text}
                </button>
              )}
            </div>

            {stats?.length > 0 && (
              <div className="grid grid-cols-3 gap-8 mt-12 pt-8 border-t border-gray-200">
                {stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div
                      className="text-3xl md:text-4xl font-bold mb-2"
                      style={{ color: customStyles.container?.titleColor || '#111827' }}
                    >
                      {stat.value}
                    </div>
                    <div
                      className="text-sm md:text-base"
                      style={{ color: customStyles.container?.subtitleColor || '#4B5563' }}
                    >
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="relative h-[400px] md:h-[550px] lg:h-full order-1 lg:order-2">
            {renderHeroMedia(
              customStyles.container?.heroImage || 'https://placehold.co/800x600?text=Hero+Media',
              "Hero showcase",
              "rounded-lg lg:rounded-l-3xl shadow-2xl"
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const CenteredDark = () => (
    <div className={`relative overflow-hidden min-h-[600px] lg:min-h-[800px] flex items-center ${finalContainerClass}`} style={containerStyle}>
      {bgImage?.match(/\.(mp4|webm|mov)$/i) && (
        <video
          src={bgImage}
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      <div className="absolute inset-0 bg-black/50" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center z-10">
        {badge && (
          <div
            className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-8 border border-white/20 backdrop-blur-sm"
            style={{
              backgroundColor: customStyles.container?.badgeBg || 'rgba(255,255,255,0.15)',
              color: customStyles.container?.badgeText || '#ffffff',
            }}
          >
            <Sparkles className="w-5 h-5" />
            <span className="font-medium">{badge}</span>
          </div>
        )}
        <h1
          className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight"
          style={{ color: customStyles.container?.titleColor || '#ffffff' }}
        >
          {title}
        </h1>
        <p
          className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto"
          style={{ color: customStyles.container?.subtitleColor || 'rgba(255,255,255,0.9)' }}
        >
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-5 justify-center">
          <button
            className="px-10 py-5 rounded-full font-bold text-lg shadow-xl transition-transform hover:scale-105"
            style={{
              backgroundColor: customStyles.container?.ctaPrimaryBg || '#ffffff',
              color: customStyles.container?.ctaPrimaryText || '#111827',
            }}
          >
            {ctaPrimary?.text || "Start Shopping"}
            <ArrowRight className="ml-3 w-6 h-6" />
          </button>
          {ctaSecondary?.text && (
            <button
              className="px-10 py-5 rounded-full font-bold text-lg border-2 border-white/40 backdrop-blur-sm transition-transform hover:scale-105 text-white"
            >
              {ctaSecondary.text}
            </button>
          )}
        </div>
      </div>
    </div>
  );

  const ImageOverlay = () => (
    <div className={`relative min-h-[600px] lg:min-h-[800px] flex items-center ${finalContainerClass}`} style={containerStyle}>
      {bgImage && (
        bgImage.match(/\.(mp4|webm|mov)$/i) ? (
          <video
            src={bgImage}
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : (
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        )
      )}

      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 z-10">
        <div className="max-w-3xl">
          {badge && (
            <div
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-6 backdrop-blur-md border border-white/30 shadow-lg"
              style={{
                backgroundColor: customStyles.container?.badgeBg || 'rgba(255,255,255,0.9)',
                color: customStyles.container?.badgeText || '#111827',
              }}
            >
              <Sparkles className="w-5 h-5" />
              <span className="font-semibold">{badge}</span>
            </div>
          )}
          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-8 leading-tight text-white"
            style={{ color: customStyles.container?.titleColor || '#ffffff' }}
          >
            {title}
          </h1>
          <p
            className="text-xl md:text-2xl mb-12 leading-relaxed text-white/90"
            style={{ color: customStyles.container?.subtitleColor || 'rgba(255,255,255,0.9)' }}
          >
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-5">
            <button
              className="px-10 py-5 rounded-full font-bold text-lg shadow-2xl transition-transform hover:scale-105"
              style={{
                backgroundColor: customStyles.container?.ctaPrimaryBg || '#ffffff',
                color: customStyles.container?.ctaPrimaryText || '#111827',
              }}
            >
              {ctaPrimary?.text || "Explore Now"}
              <ArrowRight className="ml-3 w-6 h-6" />
            </button>
            {ctaSecondary?.text && (
              <button
                className="px-10 py-5 rounded-full font-bold text-lg border-2 border-white/60 backdrop-blur-sm transition-transform hover:scale-105 text-white"
              >
                {ctaSecondary.text}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const ProductShowcase = () => (
    <div className={`relative overflow-hidden ${finalContainerClass}`} style={containerStyle}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1 relative">
            <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8 lg:p-12 aspect-square overflow-hidden shadow-2xl">
              {renderHeroMedia(
                product?.image || customStyles.container?.heroImage || "https://placehold.co/800x800?text=Featured+Product",
                product?.name || "Featured Product",
                "drop-shadow-2xl transition-transform hover:scale-105 duration-700"
              )}

              {badge && (
                <div
                  className="absolute top-6 left-6 px-5 py-2 rounded-full text-sm font-bold shadow-lg"
                  style={{
                    backgroundColor: customStyles.container?.badgeBg || '#dc2626',
                    color: customStyles.container?.badgeText || '#ffffff',
                  }}
                >
                  {badge}
                </div>
              )}

              {product?.rating && (
                <div className="absolute bottom-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-3 shadow-xl border border-gray-100">
                  <div className="flex items-center gap-2">
                    <Star className="w-6 h-6 fill-yellow-400 text-yellow-400" />
                    <span className="font-bold text-xl">{product.rating.toFixed(1)}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{product.reviews || 0} reviews</p>
                </div>
              )}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            {badge && (
              <div className="inline-flex items-center gap-2 bg-indigo-50 text-indigo-700 px-5 py-2 rounded-full mb-6">
                <TrendingUp className="w-5 h-5" />
                <span className="font-semibold text-sm">Featured</span>
              </div>
            )}
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
              style={{ color: customStyles.container?.titleColor || '#111827' }}
            >
              {product?.name || title}
            </h1>
            <div className="flex items-baseline gap-4 mb-8">
              <span
                className="text-5xl md:text-6xl font-extrabold"
                style={{ color: customStyles.container?.ctaPrimaryBg || '#111827' }}
              >
                KES {(product?.price || 12999).toLocaleString()}
              </span>
              {product?.originalPrice && (
                <>
                  <span className="text-2xl text-gray-400 line-through">
                    KES {product.originalPrice.toLocaleString()}
                  </span>
                  <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-bold">
                    Save {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}%
                  </span>
                </>
              )}
            </div>
            <p
              className="text-lg md:text-xl mb-10 leading-relaxed"
              style={{ color: customStyles.container?.subtitleColor || '#4B5563' }}
            >
              {subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-5">
              {!isInCart(product?.id) ? (
  <button
    onClick={() => addToCart(product, 1)}
    className="group inline-flex items-center justify-center px-10 py-5 rounded-full font-bold text-lg shadow-xl transition-transform hover:scale-105 min-w-[200px]"
    style={{
      backgroundColor: customStyles.container?.ctaPrimaryBg || '#111827',
      color: customStyles.container?.ctaPrimaryText || '#ffffff',
    }}
  >
    <ShoppingBag className="mr-3 w-6 h-6" />
    {ctaPrimary?.text || "Add to Cart"}
  </button>
) : (
  <div className="inline-flex items-center px-10 py-5 rounded-full font-bold text-lg shadow-xl min-w-[200px] bg-gray-900 text-white">
    <button
     onClick={(e) => {
                          e.stopPropagation();
                          changeQuantity(product.id, -1);
                        }}
      disabled={getQuantity(product.id) <= 1}
      className="p-2 disabled:opacity-50"
    >
      <Minus className="w-5 h-5" />
    </button>
    <span className="w-12 text-center text-xl">{getQuantity(product.id)}</span>
    <button
       onClick={(e) => {
                          e.stopPropagation();
                          changeQuantity(product.id, 1);
                        }}
      className="p-2"
    >
      <Plus className="w-5 h-5" />
    </button>
  </div>
)}

              <button
                onClick={() => product?.id && navigate(`/products/${product.id}`)}
                className="inline-flex items-center justify-center px-10 py-5 rounded-full font-bold text-lg border-2 transition-transform hover:scale-105 min-w-[200px]"
                style={{
                  borderColor: customStyles.container?.ctaSecondaryBorder || '#6b7280',
                  color: customStyles.container?.ctaSecondaryText || '#374151',
                }}
              >
                {ctaSecondary?.text || "View Details"}
                <ArrowRight className="ml-3 w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const ProductGrid = () => (
    <div className={`relative overflow-hidden ${finalContainerClass}`} style={containerStyle}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-20">
        <div className="text-center mb-16">
          {badge && (
            <div
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-6"
              style={{
                backgroundColor: customStyles.container?.badgeBg || '#f3f4f6',
                color: customStyles.container?.badgeText || '#111827',
              }}
            >
              <Package className="w-5 h-5" />
              <span className="font-medium">{badge}</span>
            </div>
          )}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
            style={{ color: customStyles.container?.titleColor || '#111827' }}
          >
            {title}
          </h1>
          <p
            className="text-xl md:text-2xl max-w-3xl mx-auto mb-10"
            style={{ color: customStyles.container?.subtitleColor || '#4B5563' }}
          >
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <button
              className="inline-flex items-center px-10 py-5 rounded-full font-bold text-lg shadow-xl transition-transform hover:scale-105"
              style={{
                backgroundColor: customStyles.container?.ctaPrimaryBg || '#111827',
                color: customStyles.container?.ctaPrimaryText || '#ffffff',
              }}
            >
              <ShoppingBag className="mr-3 w-6 h-6" />
              {ctaPrimary?.text || "Shop Collection"}
              <ArrowRight className="ml-3 w-6 h-6" />
            </button>
            {ctaSecondary?.text && (
              <button
                className="inline-flex items-center px-10 py-5 rounded-full font-bold text-lg border-2 transition-transform hover:scale-105"
                style={{
                  borderColor: customStyles.container?.ctaSecondaryBorder || '#6b7280',
                  color: customStyles.container?.ctaSecondaryText || '#374151',
                }}
              >
                {ctaSecondary.text}
              </button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="group bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                {renderHeroMedia(
                  product?.image || customStyles.container?.heroImage || `https://placehold.co/600x600?text=Product+${i}`,
                  `Product ${i}`,
                  "group-hover:scale-110 transition-transform duration-700"
                )}
                <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-md">
                  -20%
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl mb-3 line-clamp-2">
                  {product?.name ? `${product.name} ${i}` : `Featured Product ${i}`}
                </h3>
                <div className="flex items-center gap-2 mb-4">
                  {[...Array(5)].map((_, idx) => (
                    <Star key={idx} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                  <span className="text-sm text-gray-600 ml-1">(4.9)</span>
                </div>
                <div className="flex items-baseline gap-3 mb-6">
                  <span className="text-3xl font-extrabold text-gray-900">
                    KES {(product?.price || 12999).toLocaleString()}
                  </span>
                  {product?.originalPrice && (
                    <span className="text-lg text-gray-400 line-through">
                      KES {product.originalPrice.toLocaleString()}
                    </span>
                  )}
                </div>

                {!isInCart(product?.id) ? (
  <button
    onClick={() => addToCart(product, 1)}
    className="group inline-flex items-center justify-center px-10 py-5 rounded-full font-bold text-lg shadow-xl transition-transform hover:scale-105 min-w-[200px]"
    style={{
      backgroundColor: customStyles.container?.ctaPrimaryBg || '#111827',
      color: customStyles.container?.ctaPrimaryText || '#ffffff',
    }}
  >
    <ShoppingBag className="mr-3 w-6 h-6" />
    {ctaPrimary?.text || "Add to Cart"}
  </button>
) : (
  <div className="inline-flex items-center px-10 py-5 rounded-full font-bold text-lg shadow-xl min-w-[200px] bg-gray-900 text-white">
    <button
      onClick={() => changeQuantity(product.id, -1)}
      disabled={getQuantity(product.id) <= 1}
      className="p-2 disabled:opacity-50"
    >
      <Minus className="w-5 h-5" />
    </button>
    <span className="w-12 text-center text-xl">{getQuantity(product.id)}</span>
    <button
      onClick={() => changeQuantity(product.id, 1)}
      className="p-2"
    >
      <Plus className="w-5 h-5" />
    </button>
  </div>
)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className={finalContainerClass} style={containerStyle}>
      {preset === 'split-layout' && <SplitLayout />}
      {preset === 'centered-dark' && <CenteredDark />}
      {preset === 'image-overlay' && <ImageOverlay />}
      {preset === 'product-showcase' && <ProductShowcase />}
      {preset === 'product-grid' && <ProductGrid />}
    </div>
  );
};

export default HeroSection;